import React from "react";
import Header from "../components/header/header";
import WebDevelopment from "../sections/WebDevelopment/WebDevelopment";
import Footer from "../components/footer/footer";
function webdev() {
  return (
    <>
      <Header />
      <WebDevelopment />
      <Footer />
    </>
  );
}

export default webdev;
